import { AsyncType, createAsyncTypes, createCRUDAsyncTypes } from "@ctra/utils";

const ns = "app/ask-ida";

/**
 * CRUD a single Ask Ida tracker
 * @category Type
 */
const [CREATE_ASK_IDA_TRACKER, FETCH_ASK_IDA_TRACKER, , DELETE_ASK_IDA_TRACKER]: AsyncType[] =
  createCRUDAsyncTypes(ns, "ASK_IDA_TRACKER", { primary: "id" });

/**
 * Fetch a list of Ask Ida trackers
 * @category Type
 */
const FETCH_ASK_IDA_TRACKER_LIST: AsyncType = createAsyncTypes(ns, "FETCH_ASK_IDA_TRACKER_LIST", {
  primary: "hash"
});

export default {
  CREATE_ASK_IDA_TRACKER,
  FETCH_ASK_IDA_TRACKER,
  DELETE_ASK_IDA_TRACKER,
  FETCH_ASK_IDA_TRACKER_LIST
};
